<div class="confirmPurchaseWrap section">
    <div class="gameHeader subHeader">
        <button class="back leftbtn" (click)="closeTicket()">
            <svg class="svgicon">
                <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
            </svg>
        </button>
        <div class="pageIndicator">
            <div class="title">{{'dge.purchase_det' | translate}}</div>
            <div class="userinfo">
                <div class="userName">{{userInfo?.playername}}</div>
                <!-- <div class="balanceWrap" innerHTML="{{userInfo?.balance | custCurrency}}"></div> -->
                <div class="balanceWrap" *ngIf="clientCode != 'guinee'" innerHTML="{{userInfo?.balance | custCurrency}}"></div>
                <div class="balanceWrap" *ngIf="clientCode == 'guinee'" innerHTML="{{gameData?.nativeCurrency | currencySymbol}} {{numberWithSpaces(userInfo?.balance)}}"></div>
            </div>
        </div>
    </div>
    <div class="purcahseDetailWrap">
        <div class="sectionWrapper">
            <div class="purcahseDetail-box">
                <div class="title">{{'common.'+ gameData?.gameCode | translate}}
                    <div class="subtitle" *ngIf="gameData?.drawRespVOs?.length == 1">
                        <span class="date">{{gameData?.drawRespVOs[0]?.drawDateTime | date:'dd/MM/y HH:mm:ss'}}</span>
                    </div>
                </div>
                <div class="playedRowWrap">
                    <div class="item-row" *ngFor="let panel of userData?.panelData; let pIndex = index;">
                        <div class="col1">
                            <div class="selection"
                                *ngIf="panel.pickType != 'Banker' && panel.pickType != 'Banker1AgainstAll' && betData[panel.betType].winMode == 'MAIN'">
                                <ng-container *ngIf="gameCode != 'powerball' && gameCode != 'FiveByFortyNineLottoWeekly' && gameCode != 'BichoRapido'">
                                    <div class="ballBox">
                                        <div class="ballWrap ball-{{numberArray[pickedNo]?.color}}"
                                            *ngFor="let pickedNo of panel.pickedValues; let k = index;">
                                            {{pickedNo}}
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="gameCode == 'powerball' || gameCode == 'FiveByFortyNineLottoWeekly'">
                                    <div class="ballBox">
                                        <div class="ballWrap ball-{{numberArray[pickedNo]?.color}}"
                                            *ngFor="let pickedNo of panel.pickedValues[0]; let k = index;">
                                            {{pickedNo}}
                                        </div>
                                    </div>
                                    <span class="plusSign">+</span>
                                    <div class="ballBox">
                                        <div class="ballWrap ball-{{numberArray2[pickedNo]?.color}}"
                                            *ngFor="let pickedNo of panel.pickedValues[1]; let k = index;">
                                            {{pickedNo}}
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="gameCode == 'BichoRapido'">
                                    <div class="valuebox" *ngIf="panel.betType != 'Groupo' && panel.betType != 'TurnoDeGroupo'">
                                        <ng-container *ngFor="let pickedNo of panel?.pickedValues; let k = index;">
                                            {{pickedNo}}
                                        </ng-container>
                                    </div>
                                    <div class="animalSelectBox" *ngIf="panel.betType == 'Groupo' || panel.betType == 'TurnoDeGroupo'">
                                        <ng-container *ngFor="let pickedNo of panel?.pickedValues; let k = index;">
                                        <div class="title">

                                                <div class="num">{{pickedNo}}</div>
                                                <div class="name">{{panel?.pickedValuesName && panel?.pickedValuesName[k] ? panel?.pickedValuesName[k] : ''}}</div>
                                            <!-- <div class="num">{{panel?.pickedValues[0]}}</div> -->
                                            <!-- <div class="name">{{panel?.pickName}}</div> -->
                                        </div>
                                        <div class="img-num-wrap" *ngIf="panel?.pickedValuesName && panel?.pickedValuesName[k]">
                                            <div class="img">
                                                <img src="assets/images/animals/{{pickedNo}}{{panel?.pickedValuesName[k]}}.jpg" alt="{{panel?.pickedValuesName[k]}}">
                                            </div>
                                            <div class="core-nums">
                                                <div class="num">{{panel?.pickedValuesArray[k][0]}}</div>
                                                <div class="num">{{panel?.pickedValuesArray[k][1]}}</div>
                                                <div class="num">{{panel?.pickedValuesArray[k][2]}}</div>
                                                <div class="num">{{panel?.pickedValuesArray[k][3]}}</div>
                                            </div>
                                        </div>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="selection"
                                *ngIf="panel.pickType == 'Banker' || panel.pickType == 'Banker1AgainstAll'">
                                <div class="txt">UL-</div>
                                <div class="ballBox">
                                    <div class="ballWrap ball-{{numberArray[pickedNo]?.color}}"
                                        *ngFor="let pickedNo of panel.pickedValues[0]; let k = index;">
                                        {{pickedNo}}
                                    </div>
                                </div>
                            </div>
                            <div class="selection" *ngIf="panel.pickType == 'Banker'">
                                <div class="txt">LL-</div>
                                <div class="ballBox">
                                    <div class="ballWrap ball-{{numberArray[pickedNo]?.color}}"
                                        *ngFor="let pickedNo of panel.pickedValues[1]; let k = index;">
                                        {{pickedNo}}
                                    </div>
                                </div>
                            </div>
                            <div class="selection" *ngIf="betData[panel.betType].winMode != 'MAIN'">
                                <div class="valuebox" *ngIf="betData[panel.betType].winMode == 'COLOR'">
                                    <div
                                        class="colorDot ball-{{betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1] | lowercase}}">
                                    </div>
                                    {{'dge.'+getSideBetPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1]) | translate}}
                                </div>
                                <div class="valuebox" *ngIf="betData[panel.betType].winMode == 'SUM'">
                                    {{(betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[0] == 0 ? 'dge.&lt; ' + betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[2] : 'dge.&gt; '
                                        + betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[0])  | translate}}
                                </div>
                                <div class="valuebox" *ngIf="betData[panel.betType].winMode == 'ODD_EVEN'">
                                    {{'dge.'+getSideBetPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1]) | translate}}
                                </div>
                                <div class="valuebox" *ngIf="betData[panel.betType].winMode == 'PATTERN'">
                                    {{'dge.'+getSideBetPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].range[0].pickValue) | translate}}
                                </div>
                            </div>
                            <div class="detail small" *ngIf="gameCode != 'powerball' && gameCode != 'FiveByFortyNineLottoWeekly' && gameCode != 'BichoRapido'">
                                <span>
                                    {{(betData[panel.betType].winMode == 'MAIN' ? 'dge.mainbet' : 'dge.sidebet') | translate}}
                                </span>
                                <span class="separator">:</span>
                                <span>
                                    {{'dge.'+betData[panel.betType].betDispName | translate}}
                                </span>
                                <span class="separator">-</span>
                                <span>
                                    {{'dge.'+getPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].code, betData[panel.betType].pickTypeData.pickType[panel.pickType].name, panel?.quickPick) | translate}}
                                </span>
                                <ng-container *ngIf="betData[panel.betType].winMode == 'MAIN'">
                                    <span class="separator">-</span>
                                    <span>
                                        {{numberOfLines(pIndex)}}
                                        {{(numberOfLines(pIndex) > 1 ? 'dge.lines' : 'dge.line') | translate}}
                                    </span>
                                </ng-container>
                            </div>
                            <div class="detail small" *ngIf="gameCode == 'powerball' || gameCode == 'FiveByFortyNineLottoWeekly'">
                                <span>
                                    {{'dge.'+betData[panel.betType].betDispName | translate}}
                                </span>
                                <span class="separator">-</span>
                                <span>
                                    {{'dge.'+getPickName(betData[panel.betType].pickTypeData.pickType[panel.pickType].code, betData[panel.betType].pickTypeData.pickType[panel.pickType].name, panel?.quickPick) | translate}}
                                </span>
                            </div>
                            <div class="detail small" *ngIf="gameCode == 'BichoRapido'">{{'dge.'+panel.pickType | translate}}</div>
                        </div>
                        <div class="col2">
                            <div class="amountWrap" *ngIf="clientCode !='guinee'" innerHTML="{{calculatePanelPrice(pIndex) | custCurrency}}"></div>
                            <div class="amountWrap" *ngIf="clientCode =='guinee'">{{gameData?.nativeCurrency | currencySymbol}}<br><span class="no-wrap">{{numberWithSpaces(calculatePanelPrice(pIndex))}}</span></div>
                        </div>
                        <div class="col3" (click)="removePanel(pIndex)">
                            <svg class="svgicon trashIcon">
                                <use xlink:href="assets/images/sprite-sheet.svg#icon-trash"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="confirmFooter fix-bottom bg-white">
        <div class="sectionWrapper">
            <div class="drawNumSelection" *ngIf="gameData?.drawRespVOs?.length > 1">
                <div class="label">{{'dge.no_draw' | translate}}</div>
                <div class="valueSelector">
                    <div class="btnWrap btn" (click)="drawChange('-')"><span>-</span></div>
                    <div class="inputWrap">
                        <input type="text" readonly maxlength="2" [(ngModel)]="numOfDrawsSelected"
                            (keyup)="onDrawInputChange()">
                    </div>
                    <div class="btnWrap btn" (click)="drawChange('+')"><span>+</span></div>
                </div>
                <div class="separator"><span class="txt">{{'dge.or' | translate}}</span></div>
                <div class="customSelectorBtn" (click)="openAdvDrawPopup()">
                    <button>
                        <div class="iconWrap">
                            <span class="badge" *ngIf="advanceDrawCount != '0'">{{advanceDrawCount}}</span>
                            <svg class="svgicon">
                                <use xlink:href="assets/images/sprite-sheet.svg#icon-advanceddraw"></use>
                            </svg>
                        </div>
                        <div class="btnText">{{'dge.draw_list' | translate}}</div>
                    </button>
                </div>
            </div>
            <div class="powerzone">
                <div class="betInfoWrap">
                    <div class="betInfo" *ngIf="clientCode !='guinee'">
                        <div class="txt">{{userData?.panelData?.length}}</div>
                        <div class="label">{{'dge.totbet' | translate}}</div>
                    </div>
                    <div class="betInfo">
                        <div class="txt" *ngIf="clientCode !='guinee'" innerHTML="{{calculateTotalPrice() | custCurrency}}"></div>
                        <div class="txt"  *ngIf="clientCode =='guinee'" innerHTML="{{gameData?.nativeCurrency | currencySymbol}} {{numberWithSpaces(calculateTotalPrice())}}"></div>
                        <div class="label">{{'dge.totbetval' | translate}}</div>
                    </div>
                </div>
                <button class="buyNowBtn btn-primary" (click)="confirmTicketPurchase()">
                    {{'dge.cnfrm_buy' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>
